module.exports = __webpack_public_path__ + "img/luton-town-logo-icon.983c40d1.png";